import { render, staticRenderFns } from "./wednesday.vue?vue&type=template&id=3537241e&scoped=true"
import script from "./wednesday.vue?vue&type=script&lang=js"
export * from "./wednesday.vue?vue&type=script&lang=js"
import style0 from "./wednesday.vue?vue&type=style&index=0&id=3537241e&prod&lang=css"
import style1 from "./wednesday.vue?vue&type=style&index=1&id=3537241e&prod&lang=less&scoped=true"
import style2 from "./wednesday.vue?vue&type=style&index=2&id=3537241e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3537241e",
  null
  
)

export default component.exports